import ContainerHead from "../../molecules/ContainerHead";
import BlogOverviewContent from "./BlogOverviewContent";
import SwiperElement from "../../molecules/SwiperElement";
import {Tracking} from "../../../tracking/tracking";
import {loadBlogs} from "../../../helpers/loadBlogs";

class BlogOverviewSwiper {
  // Blog Overview Swiper Parameters
  // 'slidesOffset*' seems to be a bit buggy, when entering different
  // breakpoint ranges, thus added the appropriate values to every bp
  private static swiperParams = {
    navigation: false,
    updateOnWindowResize: true,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    slidesPerView: 1.25,
    breakpoints: {
      481: {
        slidesPerView: 1.6,
      },
      651: {
        slidesPerView: 1.8,
      },
      768: {
        slidesPerView: 2.25,
      },
      851: {
        slidesPerView: 2.75,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
      },
      941: {
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        slidesPerView: 3,
      },
      1132: {
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        slidesPerView: 3,
      },
    },
    on: {
      slideChange: () => {
        Tracking.sendEvent("Homepage.BlogOverviewSwiper.Swiped");
      },
    },
  };

  public static run(section: HTMLElement) {
    const swiperContainer = section.querySelector<HTMLElement>("swiper-container");
    if (!swiperContainer) {
      return;
    }

    void loadBlogs().then((blogs) => {
      if (!blogs.length) {
        swiperContainer.remove();

        return;
      }

      const containerHead: HTMLElement | null = section.querySelector(".react-container-head");
      if (containerHead) {
        new ContainerHead(containerHead);
      }

      blogs.forEach((blog) => {
        const swiperSlide = document.createElement("swiper-slide");
        swiperSlide.classList.add("swiper-slide");
        swiperContainer.insertAdjacentElement("beforeend", swiperSlide);
        new BlogOverviewContent(swiperSlide, blog);
      });

      SwiperElement.run(section, BlogOverviewSwiper.swiperParams);
    });
  }
}

export default BlogOverviewSwiper;
